export default "__VITE_ASSET__DcbpTsvm__"